import React, { useEffect } from 'react';
import { StatusCodes } from 'http-status-codes';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';

import LoadingPage from './LoadingPage';
import ErrorPage from './ErrorPage';
import SystemMessagePage from './SystemMessagePage';

import InterestUri from '../Enum/InterestUri';

import { tokenProvided } from '../Store/Auth/action';
import useGetError from '../Hook/UseGetError';
import useGetLastResponseCode from '../Hook/Interest/UseGetLastResponseCode';
import useGetEngine from '../Hook/UseGetEngine';
import isAllowed from '../Hook/Interest/UseAllowedUrl';
import ForbiddenPage from './ForbiddenPage';

const AuthenticationPage: React.FC = () => {
    const dispatch = useDispatch();
    let error = useGetError();
    const location = queryString.parse(window.location.search.replace('?', ''));
    const { token } = location;
    let { url } = location;
    const { isProductPropertiesOnly } = useGetEngine();

    if (url === undefined) {
        if (isProductPropertiesOnly()) {
            url = InterestUri.PropertiesPerLabel;
        }

        if (!isProductPropertiesOnly()) {
            url = InterestUri.FixedPeriod;
        }
    }

    if (!Object.values(InterestUri).includes(url as InterestUri)) {
        error = new Error('De opgevraagde url bestaat niet.');
    }

    useEffect(() => {
        if (typeof token === 'string' && error === null && isAllowed(url as InterestUri)) {
            dispatch(tokenProvided(token, url as string));
        }
    });

    const lastResponseCode = useGetLastResponseCode();

    if (lastResponseCode === StatusCodes.SERVICE_UNAVAILABLE) {
        return (<SystemMessagePage />);
    }

    if (!isAllowed(url as InterestUri)) {
        return (<ForbiddenPage message="De opgevraagde url is niet toegankelijk." />);
    }

    if (error !== null || typeof token !== 'string') {
        return (<ErrorPage />);
    }

    return (<LoadingPage />);
};

export default AuthenticationPage;
